<template>
  <div>
    <form-input
      rules="required"
      :label="label"
      v-model="ngoName"
      :state="getOrg.length > 0 && ngoName.length > 0 ? true : false"
      withValidation
    />
    <div class="bg-gray">
      <!-- <div
        v-if="loading"
        style="min-height: 200px"
        class="d-flex justify-content-center align-items-center"
      >
        <b-spinner
          class="mx-1"
          style="width: 1.5rem; height: 1.5rem"
          variant="info"
        />
        <h6 class="text-info">جاري التحميل...</h6>
      </div> -->
      <div
        v-if="getOrg.length === 0 && ngoName.length > 0 && !loading"
        class="text-success text-right mb-1"
        style="font-size: small"
      >
        لا يوجد أسماء مشابهة
      </div>
      <template v-if="getOrg.length > 0 && ngoName.length > 0 && !loading">
        <div class="text-danger text-center mb-1" style="font-size: medium">
          لا يمكن اختيار هذا الاسم لانه مستخدم
        </div>
        <h6 class="mb-1">قائمة بأسماء المنظمات المشهرة</h6>

        <div class="ngo-cont">
          <b-list-group class="mb-1">
            <b-list-group-item v-for="ngo in getOrg" :key="ngo.id">{{
              ngo.name_ar
            }}</b-list-group-item>
          </b-list-group>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import FormInput from "@/components/form-input";
import { BListGroup, BListGroupItem, BSpinner } from "bootstrap-vue";
import debounce from "lodash.debounce";

export default {
  components: {
    FormInput,
    BListGroup,
    BListGroupItem,
    BSpinner,
  },
  props: {
    value: String,
    label: {
      type: String,
      default: () => "اسم المنظمة",
    },
  },
  data() {
    return {
      getOrg: [],
      loading: false,
    };
  },
  watch: {
    ngoName: debounce(function (value) {
      this.$store
        .dispatch(`NgoHome/main/getOrganizations`, {
          currentPage: 1,
          filter: value,
        })
        .then(() => {
          this.getOrg = [...this.orgs.data];
          this.loading = false;
        });
    }, 300),
  },
  computed: {
    orgs() {
      return this.$store.getters["NgoHome/main/ngoOrganizations"];
    },
    ngoName: {
      set(val) {
        this.loading = true;
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>
